import {
  Droplets,
  CircleDot,
  Toilet,
  Waves,
  Container,
  Gauge,
  Truck,
  Search,
  Wrench,
  Settings,
} from "lucide-react";

const MAP = {
  Droplets,
  CircleDot,
  Toilet,
  Waves,
  Container,
  Gauge,
  Truck,
  Search,
  Wrench,
  Settings,
};

export const ServiceIcon = ({ name, className = "w-6 h-6" }) => {
  const Icon = MAP[name] || Wrench;
  return <Icon className={className} />;
};

export default ServiceIcon;
